<template>
  <div>
    <div class="void-dialog-header">
      <span>Confirmation</span>
    </div>
    <div class="void-dialog-body">
      <span v-html="displayMessage"></span>
    </div>
    <div class="void-dialog-footer">
      <button type="button" class="btn btn-secondary" @click="closeAction()">NO</button>
      <button type="button" class="btn btn-primary" @click="confirmAction()" :title="action">YES</button>
    </div>
  </div>
</template>

<script>
  import api from './../http'
  export default {
    name: 'FinanceVoidContract',
    props: {
      id: Number,
      canVoid: Number,
      customerId: Number
    },
    canVoid: 0,

    computed: {
      displayMessage(){
        if(!this.canVoid) {
          return "Finance Contract cannot be voided: Receipts attached<br/>To view the receipt(s), click Yes"
        }
        return "Are you sure you want to void the Finance Contract?"
      }
    },

    methods: {
      closeAction () {
        this.$emit('closeAction')
      },
      confirmAction () {
        if(this.canVoid) {
          api.putRequest('/finance/' + this.id + '/void', '').then(
            (data) => {
              this.$emit('closeAction')
            }
          );
        }
        else {
          window.location.href = '/customersDisplay.php?id=' + this.customerId + '&type=receipts'
        }
      }
    }
  }
</script>

<style scoped>
  .void-dialog-header {
    height: 35px;
    background-color: #2A95CC;
    padding: 8px;
    top: 0;
    color: white;
    font-weight: 700;
    font-size: 13px;
  }

  .void-dialog-body {
    padding: 23px;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
  }

  .void-dialog-footer {
    height: 50px;
    width:100%;
    position:absolute;
    bottom: 0;
    padding: 7px;
    border-top: 1px solid #428bca;
  }

  .void-dialog-footer button {
    margin-left: 9px;
    float: right;
    border-radius: 0px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
    padding: 3px 15px;
    font-size: 11px;
    font-weight: 500;
    margin-top: 10px;
  }
</style>

